import { jsx as o } from "react/jsx-runtime";
import { DropdownMenuItemMobile as u } from "../dropdown-menu-item/index.js";
import { UserImage as g } from "../account-link/user-image.js";
import t from "./styles.module.less.js";
import p from "../folder.svg.js";
import d from "../settings.svg.js";
import f from "../logout.svg.js";
const b = (c) => {
  const {
    getTranslation: e,
    language: a,
    handleLogout: i,
    hasNotifications: s,
    userImage: r,
    onClickUserImage: n,
    children: m
  } = c;
  return /* @__PURE__ */ o(
    u,
    {
      language: a,
      titleLabel: e("pages.account"),
      link: "account",
      classNames: {
        container: t.subMenuContainer,
        itemRow: t.itemRowClassName
      },
      items: [
        // {
        //   title: getTranslation('account.new-case'),
        //   icon: (
        //     <div className={styles.newCaseWrapper}>
        //       <PlusIcon className={styles.newCaseIcon} />
        //       <img src={PlusIconHover} className={styles.newCaseIconHover} />
        //     </div>
        //   ),
        //   path: '/chat?newCase=true',
        //   isGradient: true,
        // },
        {
          title: e("account.my-cases"),
          icon: /* @__PURE__ */ o(p, { className: t.accountIcon }),
          path: "/account"
        },
        {
          title: e("account.settings"),
          icon: /* @__PURE__ */ o(d, { className: t.accountIcon }),
          path: "/account/edit"
        },
        {
          title: e("account.sign-out"),
          icon: /* @__PURE__ */ o(f, { className: t.accountIcon }),
          onClick: i
        }
      ],
      iconComponent: (l) => /* @__PURE__ */ o(
        "div",
        {
          onClick: () => n ? n(l) : void 0,
          className: t.userImageWrapper,
          children: /* @__PURE__ */ o(
            g,
            {
              userImage: r,
              hasNotifications: s
            }
          )
        }
      ),
      children: m ?? void 0
    }
  );
};
export {
  b as MobileAccountModalLink
};
